interface RegisterPayloadInput {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  organizationName?: string;
  termsAccepted: boolean;
  usageMode: "BUSINESS" | "INDIVIDUAL";
}

export function buildRegisterPayload(input: RegisterPayloadInput) {
  return {
    email: input.email,
    password: input.password,
    firstName: input.firstName,
    lastName: input.lastName,
    organizationName:
      input.usageMode === "BUSINESS" ? input.organizationName : undefined,
    termsAccepted: input.termsAccepted,
    usageMode: input.usageMode,
  };
}
